export const sliceByNumber = <T>(array: T[], number: number): T[][] =>
  array.reduce(
    (a, c, i) => (i % number == 0 ? [...a, [c]] : [...a.slice(0, -1), [...a[a.length - 1], c]]),
    []
  );
